import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/services/userService/user.service';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BlockRouteResolverForSentryService {

  public token: any;
  constructor(
    private sharedService: UserService,
    ) { }
  resolve(route: ActivatedRouteSnapshot) {
    return this.sharedService.getLoggedInuserDetails();
  }
}
